export default __webpack_public_path__ + "static/media/hashkey-1.4bd64dd8.png";